// extracted by mini-css-extract-plugin
export default {"container":"CategoryPage_container__RhIBE","title":"CategoryPage_title__CQ4zU","grid":"CategoryPage_grid__YyDKm","gridItem":"CategoryPage_gridItem__KToWE"};